import { render, staticRenderFns } from "./AdminTierView.vue?vue&type=template&id=abb67e3e&"
import script from "./AdminTierView.vue?vue&type=script&lang=js&"
export * from "./AdminTierView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports